import MockAdapter from "axios-mock-adapter"
import mockGeneral from "./mockGeneral"

export default function mockAxios(axios) {
  const mock = new MockAdapter(axios, { delayResponse: 300 })
  mockGeneral(mock)
  return mock
}
